import { Input } from "@material-tailwind/react/components/Input";
import { ThemeProvider } from "@material-tailwind/react/context/theme";
import customInputTheme from "./inputs";

export default function (props) {
    return (
        <ThemeProvider value={customInputTheme}>
            <Input {...props} />
        </ThemeProvider>
    );
}

